<template>
  <div class="second-container">
    <el-dialog v-model="showUploads">
      <span class="margin-space">新增banner图片</span>
      <el-upload
          class="avatar-uploader margin-space"
          :show-file-list="false"
          :on-success="_handleAvatarSuccess"
          action="http://clo2health.com/api/v1/imageUpload"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <el-button v-else type="danger" class="margin-space">添加图片</el-button>
      </el-upload>
      <el-button v-if="imageUrl" type="primary" class="margin-space" @click="_insertBanner">保存</el-button>
    </el-dialog>
    <AdminLeft/>
    <div class="column-con">
      <AdminTop/>
      <el-row style="width: 100%">
        <el-col :span="24" style="text-align: start;vertical-align: center">
          <el-button type="primary" round @click="_getList" style="margin-left: 20px;">刷新</el-button>

          <el-button type="success" round @click="_handleShowOrHideAlert" style="margin-left: 20px;">新建</el-button>
        </el-col>
      </el-row>
      <el-table :data="listData" stripe style="width: 100%; height: 900px;overflow-x: hidden;overflow-y: scroll;" v-loading="loading">
        <el-table-column prop="b_id" label="ID" width="180"/>
        <el-table-column label="图片" width="600">
          <template v-slot="scope">
            <img :src="scope.row.b_img" alt="img" style="width: 500px;height: 200px;">
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="300">
          <template v-slot="scope">
            <el-button round type="danger" @click="_delete(scope.row.b_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

import AdminLeft from "@/components/AdminLeft";
import AdminTop from "@/components/AdminTop";
import http from "@/util/http";
import {ElMessage, ElMessageBox} from "element-plus"

export default {
  name: "AdminBanner",
  components: {
    AdminLeft,
    AdminTop
  },
  data() {
    return {
      imageUrl: undefined,
      imgUrl: undefined,
      listData: [],
      queryData: {},
      showUploads: false,
      loading: false,
      props: {
        expandTrigger: 'hover',
      }
    }
  },
  mounted() {
    this._getList()
  },
  methods: {
    _handleAvatarSuccess(e) {
      console.log(e)
      if (e.errno !== 0) {
        ElMessage.warning('上传失败')
      }
      this.imageUrl = e.data.href
      this.imgUrl = e.data.url
      ElMessage.success('上传成功')
    },
    _handleShowOrHideAlert() {
      this.showUploads = !this.showUploads
      this.imageUrl = undefined
      this.imgUrl = undefined
    },
    _getList() {
      this.loading = true
      http.get('bannerList', {})
          .then((res) => {
            this.loading = false
            if (res.data.status !== 0) {
              ElMessage.warning(res.data.content)
              if (res.data.status === 201) {
                this.$router.push({
                  path: '/AdminLogin'
                })
              }
              return
            }
            this.listData = res.data.data
          })
    },
    _insertBanner() {
      this.loading = true
      http.post('insertBanner', {
        url: this.imgUrl
      })
          .then((res) => {
            this.loading = false
            if (res.data.status !== 0) {
              ElMessage.warning(res.data.content)
              if (res.data.status === 201) {
                this.$router.push({
                  path: '/AdminLogin'
                })
              }
              return
            }
            this._getList()
            this.showUploads = false
          })
    },
    _delete(e) {
      ElMessageBox.confirm(
          '是否删除？',
          '确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      )
          .then(() => {
            console.log("e" + e)
            http.post('deleteBanner', {
              id: parseInt(e)
            })
                .then((res) => {
                  if (res.data.status === 0) {
                    ElMessage.success(res.data.content)
                    for (let i = 0; i < this.listData.length; i++) {
                      if (this.listData[i].b_id === parseInt(e)) {
                        this.listData.splice(i, 1)
                        break
                      }
                    }
                  } else {
                    ElMessage.error(res.data.content)
                    if (res.data.status === 201) {
                      this.$router.push({
                        path: '/AdminLogin'
                      })
                    }
                  }
                })
          })
          .catch(() => {

          })
    }
  }
}
</script>

<style scoped>
.column-con {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #333333;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 500px;
  height: 200px;
  text-align: center;
}
.margin-space {
  margin: 20px 0;
}
</style>